<template>
    <div>
        <div class="d-flex justify-content-between mt-3">
            <p class="font-weight-bold text-uppercase" data-private="lipsum">
                About {{ patient.name }}
            </p>
            <p
                v-if="edit"
                class="text-primary font-weight-bold text-uppercase cursor-pointer"
                @click="save()"
            >
                <i class="fa fa-save mr-2"></i>Save
            </p>
            <a
                v-if="!edit"
                class="text-primary font-weight-bold text-uppercase cursor-pointer"
                @click="edit = true"
                ><i class="fa fa-edit mr-2"></i>Edit</a
            >
        </div>
        <hr
            style="width:100%;margin:auto;color:#c3c3c3;background: #c3c3c3; height: 1px; margin-bottom: 1rem;"
        />
        <section-field
            :top-level="true"
            :edit="edit"
            :section="patientHistory"
            :patient-data="patientData"
            :patientId="patient.id"
        ></section-field>
        <a
            v-if="edit"
            class="btn btn-sm btn-primary my-4 text-white font-weight-bold"
            @click="save()"
            ><i class="fa fa-save mr-2"></i>Save</a
        >
    </div>
</template>
<script>
import MultiField from "./MultiField";
import ListField from "./ListField";
import SectionField from "./SectionField";
export default {
    name: "AboutHistory",
    props: ["patient"],
    components: {
        MultiField,
        ListField,
        SectionField,
    },
    data() {
        return {
            edit: false,
            patientData: {},
            patientHistory: {
                name: "patient_history",
                title: "Patient history",
                fields: [
                    {
                        name: "description",
                        title: "Brief history",
                        type: "textarea",
                        value: null,
                        enabled: true,
                        required: true,
                    },
                ],
                enabled: true,
                required: true,
                sections: [
                    {
                        name: "general_information",
                        title: "General Information",
                        fields: [
                            {
                                name: "child_name",
                                title: "Child's name",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "child_nickname",
                                title: "Nickname",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "child_male_female",
                                title: "Sex",
                                type: "radio",
                                options: [
                                    {
                                        value: "male",
                                        title: "Male",
                                    },
                                    {
                                        value: "female",
                                        title: "Female",
                                    },
                                ],
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "child_dob",
                                title: "Date of birth",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "child_child_ssn",
                                title: "Child's Social Security Number",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "child_age",
                                title: "Age",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "child_height",
                                title: "Height",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "child_weight",
                                title: "Weight",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "child_hair_color",
                                title: "Hair color",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "child_eye_color",
                                title: "Eye color",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "child_distinguishing_features",
                                title:
                                    "Distinguishing features (moles, tattoos, scars, walking gait)",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "child_referring_source",
                                title: "Referring source",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                        ],
                        enabled: true,
                        required: true,
                    },
                    {
                        name: "living_situation",
                        title: "Living situation",
                        sections: [
                            {
                                name: "guardian_1_info",
                                title: "Parent/legal guardian #1 name",
                                fields: [
                                    {
                                        name: "guardian_1_name",
                                        title: "Name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_maiden_name",
                                        title: "Maiden name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "guardian_1_relationship_patient",
                                        title: "Relationship to patient",
                                        //TODO: get list of options
                                        options: [
                                            {
                                                value: "parent",
                                                title: "Parent",
                                            },
                                            {
                                                value: "adoptive_parent",
                                                title: "Adoptive parent",
                                            },
                                            {
                                                value: "step_parent",
                                                title: "Step parent",
                                            },
                                            {
                                                value: "foster_parent",
                                                title: "Foster parent",
                                            },
                                            {
                                                value: "other",
                                                title: "Other",
                                            },
                                        ],
                                        type: "select",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_dob",
                                        title: "Date of birth",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_race",
                                        title: "Race",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_marital_status",
                                        title: "Marital status",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_home_phone",
                                        title: "Home phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_cell_phone",
                                        title: "Cell phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_mobile_phone",
                                        title: "Mobile phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_email",
                                        title: "E-mail",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_home_address",
                                        title: "Home address",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_city",
                                        title: "City",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_state",
                                        title: "State",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_zip_code",
                                        title: "Zip code",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_occupation",
                                        title: "Occupation",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_1_education",
                                        title: "Highest level of education",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "guardian_2_info",
                                title: "Parent/legal guardian #2 name",
                                fields: [
                                    {
                                        name: "guardian_2_name",
                                        title: "Name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_maiden_name",
                                        title: "Maiden name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "guardian_2_relationship_patient",
                                        title: "Relationship to patient",
                                        //TODO: get list of options
                                        options: [
                                            {
                                                value: "parent",
                                                title: "Parent",
                                            },
                                            {
                                                value: "adoptive_parent",
                                                title: "Adoptive parent",
                                            },
                                            {
                                                value: "step_parent",
                                                title: "Step parent",
                                            },
                                            {
                                                value: "foster_parent",
                                                title: "Foster parent",
                                            },
                                            {
                                                value: "other",
                                                title: "Other",
                                            },
                                        ],
                                        type: "select",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_dob",
                                        title: "Date of birth",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_race",
                                        title: "Race",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_marital_status",
                                        title: "Marital status",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_home_phone",
                                        title: "Home phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_cell_phone",
                                        title: "Cell phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_mobile_phone",
                                        title: "Mobile phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_email",
                                        title: "E-mail",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_home_address",
                                        title: "Home address",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_city",
                                        title: "City",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_state",
                                        title: "State",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_zip_code",
                                        title: "Zip code",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_occupation",
                                        title: "Occupation",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "guardian_2_education",
                                        title: "Highest level of education",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: false,
                            },
                            {
                                name: "child_lives_not_both_biological_parents",
                                title: "If the child does not live with both biological parents",
                                fields: [
                                    {
                                        name: "biological_parents_frequence",
                                        title:
                                            "How often does the other biological parent see this child",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "years_together",
                                        title: "Number of years married/together",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "date_separation",
                                        title: "Approx. date of separation",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "times_married_mother",
                                        title: "Number of times the mother has married",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "times_married_father",
                                        title: "Number of times the father has married",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: false,
                                notApplicable: false,
                            },
                            {
                                name: "child_spends_time_other_caregiver",
                                title:
                                    "Does the child spend a significant amount of time (more than 4 hours a day, excluding school) with a caregiver other than someone described above?",
                                fields: [
                                    {
                                        name: "other_caregiver_name",
                                        title: "Name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "other_caregiver_relationship_patient",
                                        title: "Relationship to patient",
                                        //TODO: get list of options
                                        options: [
                                            {
                                                value: "parent",
                                                title: "Parent",
                                            },
                                            {
                                                value: "adoptive_parent",
                                                title: "Adoptive parent",
                                            },
                                            {
                                                value: "step_parent",
                                                title: "Step parent",
                                            },
                                            {
                                                value: "foster_parent",
                                                title: "Foster parent",
                                            },
                                            {
                                                value: "other",
                                                title: "Other",
                                            },
                                        ],
                                        type: "select",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "other_caregiver_dob",
                                        title: "Date of birth",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "other_caregiver_race",
                                        title: "Race",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "other_caregiver_occupation",
                                        title: "Occupation",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "other_caregiver_education",
                                        title: "Highest level of education",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: false,
                                notApplicable: false,
                            },
                        ],
                    },
                    {
                        name: "siblings",
                        title: "Siblings",
                        listName: "siblings",
                        listTitle: "Please list the child's siblings",
                        list: [],
                        listFields: [
                            {
                                name: "sibling_name",
                                title: "Name",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "sibling_age",
                                title: "Age",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "sibling_male_female",
                                title: "Sex",
                                type: "radio",
                                options: [
                                    {
                                        value: "male",
                                        title: "Male",
                                    },
                                    {
                                        value: "female",
                                        title: "Female",
                                    },
                                ],
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "sibling_full_half",
                                title: "Full/half sibling",
                                type: "radio",
                                options: [
                                    {
                                        value: "full",
                                        title: "Full",
                                    },
                                    {
                                        value: "half",
                                        title: "Half",
                                    },
                                ],
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "sibling_sibling",
                                title: "Is child in home",
                                type: "radio",
                                options: [
                                    {
                                        value: "yes",
                                        title: "Yes",
                                    },
                                    {
                                        value: "no",
                                        title: "No",
                                    },
                                ],
                                value: null,
                                enabled: true,
                                required: true,
                            },
                        ],
                        enabled: true,
                        required: false,
                    },
                    {
                        name: "changes_stressors",
                        title: "Family changes and stressors",
                        fields: [
                            {
                                name: "changes",
                                title:
                                    "Please indicate any major changes that the child is experienced or has experienced in the past 18 months (check all that apply)",
                                type: "checkbox",
                                options: [
                                    {
                                        value: "marital_discourse",
                                        title: "Marital discourse/fighting",
                                    },
                                    {
                                        value: "separation",
                                        title: "Separation",
                                    },
                                    {
                                        value: "divorce",
                                        title: "Divorce",
                                    },
                                    {
                                        value: "birth_adoption",
                                        title: "Birth/adoption of another child",
                                    },
                                    {
                                        value: "sibling_conflict",
                                        title: "Sibling conflict",
                                    },
                                    {
                                        value: "parent_child_conflict",
                                        title: "Parent-child conflict",
                                    },
                                    {
                                        value: "custody_disagreement",
                                        title: "Custody disagreement",
                                    },
                                    {
                                        value: "single_parent",
                                        title: "Single parent family",
                                    },
                                    {
                                        value: "parent_child_death",
                                        title: "Parent/sibling death",
                                    },
                                    {
                                        value: "parent_deployed",
                                        title: "Parent deployed extensively",
                                    },
                                    {
                                        value: "parent_ill",
                                        title: "Parent emotionally/mentally ill",
                                    },
                                    {
                                        value: "juvenile_court",
                                        title: "Involved in juvenile court",
                                    },
                                    {
                                        value: "abandonment",
                                        title: "Abandonment by parent",
                                    },
                                    {
                                        value: "financial_problems",
                                        title: "Financial problems",
                                    },
                                    {
                                        value: "parent_substance_abuse",
                                        title: "Parent substance abuse",
                                    },
                                    {
                                        value: "child_neglect",
                                        title: "Child neglect",
                                    },
                                    {
                                        value: "physical_abuse",
                                        title: "Physical abuse",
                                    },
                                    {
                                        value: "sexual_abuse",
                                        title: "Sexual abuse",
                                    },
                                    {
                                        value: "social_services",
                                        title:
                                            "Involved with social services/child protective services",
                                    },
                                    {
                                        value: "disagreement_rearing",
                                        title: "Parent disagreement about child rearing",
                                    },
                                    {
                                        value: "other",
                                        title: "Other",
                                    },
                                ],
                                value: [],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "group_support",
                                title: "Do you belong to a parent group or support network",
                                type: "radio",
                                options: [
                                    {
                                        value: "other",
                                        title: "Yes",
                                    },
                                    {
                                        value: "no",
                                        title: "No",
                                    },
                                ],
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medical_history",
                                title:
                                    "Please provide any medical treatment history of other family members that may be relevant",
                                type: "textarea",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                        ],
                        enabled: true,
                        required: true,
                    },
                    {
                        name: "funding_sources",
                        title: "Funding sources",
                        sections: [
                            {
                                name: "primary_insurance",
                                title: "Primary insurance company",
                                fields: [
                                    {
                                        name: "primary_type_plan",
                                        title: "Type of plan",
                                        //TODO: get list of options
                                        options: [
                                            {
                                                value: "hmo",
                                                title: "HMO",
                                            },
                                            {
                                                value: "pos",
                                                title: "POS",
                                            },
                                            {
                                                value: "ppo",
                                                title: "PPO",
                                            },
                                            {
                                                value: "other",
                                                title: "Other",
                                            },
                                        ],
                                        type: "select",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_group_number",
                                        title: "Group number",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_id_number",
                                        title: "Id number",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_policy_number",
                                        title: "Policy number",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_certificate_number",
                                        title: "Certificate number",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_phone_number",
                                        title: "Phone number",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_mental_health",
                                        title: "Mental health",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_subscribers_name",
                                        title: "Subscriber's name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_subscribers_dob",
                                        title: "Subscriber's date of birth",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_relationship_patient",
                                        title: "Relationship to patient",
                                        //TODO: get list of options
                                        options: [
                                            {
                                                value: "parent",
                                                title: "Parent",
                                            },
                                            {
                                                value: "adoptive_parent",
                                                title: "Adoptive parent",
                                            },
                                            {
                                                value: "step_parent",
                                                title: "Step parent",
                                            },
                                            {
                                                value: "foster_parent",
                                                title: "Foster parent",
                                            },
                                            {
                                                value: "other",
                                                title: "Other",
                                            },
                                        ],
                                        type: "select",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_employer",
                                        title: "Employer",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_occupation",
                                        title: "Occupation",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_employer_address",
                                        title: "Employer address",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_work_number",
                                        title: "Work number",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_insurance_image_front",
                                        title: "Insurance image (front)",
                                        type: "file",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_insurance_image_back",
                                        title: "Insurance image (back)",
                                        type: "file",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "secondary_insurance",
                                title: "Secondary insurance company",
                                fields: [
                                    {
                                        name: "secondary_type_plan",
                                        title: "Type of plan",
                                        //TODO: get list of options
                                        options: [
                                            {
                                                value: "hmo",
                                                title: "HMO",
                                            },
                                            {
                                                value: "pos",
                                                title: "POS",
                                            },
                                            {
                                                value: "ppo",
                                                title: "PPO",
                                            },
                                            {
                                                value: "other",
                                                title: "Other",
                                            },
                                        ],
                                        type: "select",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_group_number",
                                        title: "Group number",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_id_number",
                                        title: "Id number",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_policy_number",
                                        title: "Policy number",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_certificate_number",
                                        title: "Certificate number",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_phone_number",
                                        title: "Phone number",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_mental_health",
                                        title: "Mental health",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_subscribers_name",
                                        title: "Subscriber's name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_subscribers_dob",
                                        title: "Subscriber's date of birth",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_relationship_patient",
                                        title: "Relationship to patient",
                                        //TODO: get list of options
                                        options: [
                                            {
                                                value: "parent",
                                                title: "Parent",
                                            },
                                            {
                                                value: "adoptive_parent",
                                                title: "Adoptive parent",
                                            },
                                            {
                                                value: "step_parent",
                                                title: "Step parent",
                                            },
                                            {
                                                value: "foster_parent",
                                                title: "Foster parent",
                                            },
                                            {
                                                value: "other",
                                                title: "Other",
                                            },
                                        ],
                                        type: "select",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_employer",
                                        title: "Employer",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_occupation",
                                        title: "Occupation",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_employer_address",
                                        title: "Employer address",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_work_number",
                                        title: "Work number",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_insurance_image_front",
                                        title: "Insurance image (front)",
                                        type: "file",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "secondary_insurance_image_back",
                                        title: "Insurance image (back)",
                                        type: "file",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                                notApplicable: false,
                            },
                        ],
                        enabled: true,
                        required: true,
                    },
                    {
                        name: "regional_center",
                        title: "Regional center client",
                        fields: [
                            {
                                name: "center_name",
                                title: "Regional center name",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "center_manager_name",
                                title: "Case manager or service coordinator name",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "center_phone",
                                title: "Phone",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "center_age_when_accepted",
                                title: "Child's age when accepted as regional center client",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "center_age_when_started",
                                title: "Child's age when regional services began",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                        ],
                        enabled: true,
                        required: true,
                        notApplicable: false,
                    },
                    {
                        name: "school_placement",
                        title: "School placement",
                        listName: "schools",
                        listTitle:
                            "Please list all schools beginning with the current school, your child has attended",
                        list: [],
                        listFields: [
                            {
                                name: "school_list_age_started",
                                title: "Age started",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "school_list_name",
                                title: "Name of school",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "school_list_type",
                                title: "Type of class",
                                type: "select",
                                options: [
                                    {
                                        value: "regular_ed",
                                        title: "Regular Ed.",
                                    },
                                    {
                                        value: "autism",
                                        title: "Autism",
                                    },
                                    {
                                        value: "sdc",
                                        title: "SDC",
                                    },
                                    {
                                        value: "ed",
                                        title: "ED",
                                    },
                                    {
                                        value: "rsp",
                                        title: "RSP",
                                    },
                                    {
                                        value: "typical_preschool",
                                        title: "Typical preschool",
                                    },
                                    {
                                        value: "preschool_mix",
                                        title: "Preschool mix",
                                    },
                                    {
                                        value: "preschool_intensive",
                                        title: "Preschool intensive",
                                    },
                                    {
                                        value: "preschool_collab",
                                        title: "Preschool collaborative",
                                    },
                                    {
                                        value: "district_special",
                                        title: "District special Ed program",
                                    },
                                ],
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "sibling_full_half",
                                title: "Full/half sibling",
                                type: "radio",
                                options: [
                                    {
                                        value: "full",
                                        title: "Full",
                                    },
                                    {
                                        value: "half",
                                        title: "Half",
                                    },
                                ],
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "sibling_sibling",
                                title: "Is child in home",
                                type: "radio",
                                options: [
                                    {
                                        value: "yes",
                                        title: "Yes",
                                    },
                                    {
                                        value: "no",
                                        title: "No",
                                    },
                                ],
                                value: null,
                                enabled: true,
                                required: true,
                            },
                        ],
                        fields: [
                            {
                                name: "school_age_when_started",
                                title: "Child's age when school services began",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "school_iep_date",
                                title: "Date of most recent IEP",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "school_district",
                                title: "School district",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "center_age_when_accepted",
                                title: "Child's age when accepted as regional center client",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                        ],
                        sections: [
                            {
                                name: "current_class",
                                title: "For your child's current class",
                                fields: [
                                    {
                                        name: "current_class_teacher_name",
                                        title: "Teacher's name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "current_class_teacher_phone",
                                        title: "Teacher's phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "current_class_school_address",
                                        title: "School address",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "current_class_school_phone",
                                        title: "School phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "current_class_grade",
                                        title: "Grade",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "current_class_number_students",
                                        title: "Number of students",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "current_class_number_teachers",
                                        title: "Number of teachers",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "current_class_number_aids",
                                        title: "Number of aids",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "current_class_has_1to1",
                                        title: "Does your child have a 1 to 1 aide",
                                        type: "radio",
                                        options: [
                                            {
                                                value: "yes",
                                                title: "Yes",
                                            },
                                            {
                                                value: "no",
                                                title: "No",
                                            },
                                        ],
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "current_class_need_1to1",
                                        title: "Does your child need a 1 to 1 aide",
                                        type: "radio",
                                        options: [
                                            {
                                                value: "yes",
                                                title: "Yes",
                                            },
                                            {
                                                value: "no",
                                                title: "No",
                                            },
                                        ],
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "current_class_work_independently",
                                        title: "Work independently",
                                        type: "radio",
                                        options: [
                                            {
                                                value: "yes",
                                                title: "Yes",
                                            },
                                            {
                                                value: "no",
                                                title: "No",
                                            },
                                        ],
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,

                                //TODO: other/hours per week/phone/address
                            },
                        ],
                        enabled: true,
                        required: true,
                        notApplicable: false,
                    },
                    {
                        name: "birth_history",
                        title: "Regional center client",
                        fields: [
                            {
                                name: "birth_pregnancy_complications",
                                title: "Were there complications during your pregnancy",
                                type: "radio",
                                options: [
                                    {
                                        value: "yes",
                                        title: "Yes",
                                    },
                                    {
                                        value: "no",
                                        title: "No",
                                    },
                                ],
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "birth_pregnancy_complications_list",
                                title: "If yes, please list: Did you",
                                type: "checkbox",
                                options: [
                                    {
                                        value: "birth_pregnancy_complications_list_smoke",
                                        title: "smoke",
                                        checked: false,
                                    },
                                    {
                                        value: "birth_pregnancy_complications_list_drink",
                                        title: "drink",
                                        checked: false,
                                    },
                                    {
                                        value: "birth_pregnancy_complications_list_drugs",
                                        title: "take prescription/non-prescription drugs",
                                        checked: false,
                                    },
                                    {
                                        value: "other",
                                        title: "If yes, please explain",
                                        checked: false,
                                    },
                                ],
                                value: [],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "birth_pregnancy_full_term",
                                title: "Was your child carried full term?",
                                type: "radio",
                                options: [
                                    {
                                        value: "yes",
                                        title: "Yes",
                                    },
                                    {
                                        value: "no",
                                        title: "No",
                                    },
                                ],
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "birth_pregnancy_weeks",
                                title: "If no how many weeks was the child carried",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "birth_pregnancy_weight",
                                title: "Birth weight",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "birth_pregnancy_length",
                                title: "Birth length",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "birth_pregnancy_hospital_stay",
                                title: "Did your child require a lengthy hospital stay",
                                type: "radio",
                                options: [
                                    {
                                        value: "yes",
                                        title: "Yes",
                                    },
                                    {
                                        value: "no",
                                        title: "No",
                                    },
                                ],
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "birth_pregnancy_hospital_stay_info",
                                title: "If yes please explain (why and length of stay)",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                        ],
                        enabled: true,
                        required: true,
                    },
                    {
                        name: "developmental_milestones",
                        title: "Developmental milestones",
                        sections: [
                            {
                                name: "basic_milestones",
                                title:
                                    "Basic milestones (at what age did your child do the following things):",
                                fields: [
                                    {
                                        name: "milestone_rollover",
                                        title: "Rollover",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "milestone_sit",
                                        title: "Unsupported sit",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "milestone_crawl",
                                        title: "Crawl",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "milestone_walk",
                                        title: "Walk",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "milestone_babble",
                                        title: "Began to babble",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "milestone_single_words",
                                        title: "Using single words",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "milestone_short_sentences",
                                        title: "Using phrases/short sentences",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "milestone_5plus_sentences",
                                        title: "Using 5+ words sentences",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "milestone_lost_language",
                                        title: "Has child ever lost language, stopped using words",
                                        type: "radio",
                                        options: [
                                            {
                                                value: true,
                                                title: "Yes",
                                            },
                                            {
                                                value: false,
                                                title: "No",
                                            },
                                        ],
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "milestone_lost_language_when",
                                        title: "If yes, what age did you see this happen",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "milestone_vocab_size",
                                        title: "Current vocab size",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "milestone_solid_foods",
                                        title: "Started solid foods",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "milestone_fed_self",
                                        title: "Fed self with spoon",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "milestone_gave_up_bottle",
                                        title: "Gave up bottle",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "milestone_bladder_day",
                                        title: "Bladder trained - day",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "milestone_bladder_night",
                                        title: "Bladder trained - night",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "milestone_bowel_trained",
                                        title: "Bowel trained",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "milestone_tricycle",
                                        title: "Rides tricycle",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "milestone_problems_3yr",
                                        title:
                                            "During the childs first three years, were there any problems noted in the following areas",
                                        type: "checkbox",
                                        options: [
                                            {
                                                value: "milestone_problem_irritability",
                                                title: "Irritability",
                                            },
                                            {
                                                value: "milestone_problem_difficulty_sleeping",
                                                title: "Difficulty sleeping",
                                            },
                                            {
                                                value: "milestone_problem_failure_thrive",
                                                title: "Failure to thrive",
                                            },
                                            {
                                                value: "milestone_problem_poor_eye_contact",
                                                title: "Poor eye contact",
                                            },
                                            {
                                                value: "milestone_problem_seizures",
                                                title: "Convulsions/seizures",
                                            },
                                            {
                                                value: "milestone_problem_breathing",
                                                title: "Breathing problems",
                                            },
                                            {
                                                value: "milestone_problem_swallowing",
                                                title: "Food swallowing issues",
                                            },
                                            {
                                                value: "milestone_problem_eating_ruotine",
                                                title: "Eating routine food issues",
                                            },
                                            {
                                                value: "milestone_problem_crying",
                                                title: "Excessive crying",
                                            },
                                            {
                                                value: "milestone_problem_learning",
                                                title: "Early learning problems",
                                            },
                                            {
                                                value: "milestone_problem_colic",
                                                title: "Colic",
                                            },
                                            {
                                                value: "milestone_problem_tantrums",
                                                title: "Temper tantrums",
                                            },
                                            {
                                                value: "milestone_problem_withdrawn_behaviour",
                                                title: "Withdrawn behaviour",
                                            },
                                            {
                                                value: "milestone_problem_destructive_behaviour",
                                                title: "Destructive behaviour",
                                            },
                                            {
                                                value: "milestone_problem_separation",
                                                title: "Unable to separate from parent",
                                            },
                                            {
                                                value: "other",
                                                title: "Other",
                                            },
                                        ],
                                        value: [],
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "speech_development",
                                title: "Speech development",
                                fields: [
                                    {
                                        name: "speech_delay",
                                        title:
                                            "Is there any family history of speech or language delay",
                                        type: "radio",
                                        options: [
                                            {
                                                value: "yes",
                                                title: "Yes",
                                            },
                                            {
                                                value: "no",
                                                title: "No",
                                            },
                                        ],
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "speech_describe",
                                        title:
                                            "Describe your child's current communication level (verbal, non-verbal, gestures, signs, PECS, average phrase length)",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "speech_intelligibility_parents",
                                        title:
                                            "Estimate of speech intelligibility (0% cannot understand anything child says, 100% can understand everything child says) - with parents",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "speech_intelligibility_strangers",
                                        title:
                                            "Estimate of speech intelligibility (0% cannot understand anything child says, 100% can understand everything child says) - with strangers",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "speech_difficult_sounds",
                                        title:
                                            "Describe any speech sounds that your child has difficulty with",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "speech_language_home",
                                        title: "Language spoken in the home",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "speech_language_dominant",
                                        title: "Dominant language",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "speech_listening",
                                        title:
                                            "How well does your child understand what is being said to him or her (Receptive language ability to understand words, follow directions, identify objects and pictures etc)",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "play_development",
                                title: "Play development",
                                fields: [
                                    {
                                        name: "play_type",
                                        title:
                                            "What type of toys does your child enjoy playing with",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_include",
                                        title:
                                            "Does your child include you, siblings, or others in their play",
                                        type: "radio",
                                        options: [
                                            {
                                                value: "yes",
                                                title: "Yes",
                                            },
                                            {
                                                value: "no",
                                                title: "No",
                                            },
                                        ],
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_include_info",
                                        title: "If no, please explain",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_time",
                                        title: "How long does your child typically engage in play",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_mouth_toys",
                                        title: "Does your child mouth toys",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_rough",
                                        title:
                                            "Does your child seek out or avoid rough and tumble play",
                                        type: "radio",
                                        options: [
                                            {
                                                value: "yes",
                                                title: "Yes",
                                            },
                                            {
                                                value: "no",
                                                title: "No",
                                            },
                                        ],
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_rough_info",
                                        title: "If yes, please explain",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_noise",
                                        title: "Does your child enjoy toys that make noises",
                                        type: "radio",
                                        options: [
                                            {
                                                value: "yes",
                                                title: "Yes",
                                            },
                                            {
                                                value: "no",
                                                title: "No",
                                            },
                                        ],
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_noise_info",
                                        title: "If no, please explain",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_messy",
                                        title:
                                            "Does your child enjoy toys activates that are messy (i.e.play dough, finger painting, gluing, etc)",
                                        type: "radio",
                                        options: [
                                            {
                                                value: "yes",
                                                title: "Yes",
                                            },
                                            {
                                                value: "no",
                                                title: "No",
                                            },
                                        ],
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_messy_info",
                                        title: "If no, please explain",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "social_emotional",
                                title: "Social/emotional",
                                fields: [
                                    {
                                        name: "social_play_with",
                                        title:
                                            "Are there any special games, like pat-a-cake, tickle or vocal games, you or other members enjoy playing with your child",
                                        type: "radio",
                                        options: [
                                            {
                                                value: "yes",
                                                title: "Yes",
                                            },
                                            {
                                                value: "no",
                                                title: "No",
                                            },
                                        ],
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "social_play_with_info",
                                        title: "If yes, please explain",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "social_personality_familiar",
                                        title:
                                            "How would you describe your child’s personality with other familiar people",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "social_personality_unfamiliar",
                                        title:
                                            "How would you describe your child’s personality with unfamiliar people",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_same_age",
                                        title:
                                            "How does your child play with other children about the same age",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_attention",
                                        title:
                                            "How does your child get your attention to play with them",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_affection",
                                        title:
                                            "Please describe how your child seeks out and or shows affection",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_adult_most_often",
                                        title: "what adult does your child see the most often",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_feeling",
                                        title:
                                            "How does your child let you know how they are feeling (good, happy, upset, angry, frustrated)",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_smile",
                                        title: "Does your child laugh/smile easily?",
                                        type: "radio",
                                        options: [
                                            {
                                                value: "yes",
                                                title: "Yes",
                                            },
                                            {
                                                value: "no",
                                                title: "No",
                                            },
                                        ],
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_smile_trigger",
                                        title: "What makes your child smile or laugh?",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_tantrum_recover",
                                        title:
                                            "Does your child recover from tantrums fairly quickly?",
                                        type: "radio",
                                        options: [
                                            {
                                                value: "yes",
                                                title: "Yes",
                                            },
                                            {
                                                value: "no",
                                                title: "No",
                                            },
                                        ],
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "play_tantrum_calm",
                                        title: "If no, how do you help calm your child?",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "other_info",
                                title: "Other information",
                                fields: [
                                    {
                                        name: "info_strenghts_weaknesses",
                                        title:
                                            "Please list your child’s strengths, what are some things you feel your child does really well",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "info_difficulties",
                                        title:
                                            "Please list your child's greatest difficulties, what are some things that we can help you with immediately",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                        ],
                        enabled: true,
                        required: true,
                    },
                    {
                        name: "current_concerns",
                        title: "Current concerns about your child",
                        fields: [
                            {
                                name: "concerns_about_child",
                                title: "Check all that apply",
                                type: "checkbox",
                                options: [
                                    {
                                        value: "concern_language_ability",
                                        title: "Language ability",
                                    },
                                    {
                                        value: "concern_comply",
                                        title: "Doesn't comply, follow directions",
                                    },
                                    {
                                        value: "concern_spacy",
                                        title: "Sometimes seems 'spacy'",
                                    },
                                    {
                                        value: "concern_anxiety",
                                        title: "Fearful or anxiety",
                                    },
                                    {
                                        value: "concern_play_alone",
                                        title: "Usually plays alone",
                                    },
                                    {
                                        value: "concern_relationships_peer",
                                        title: "Peer relationships",
                                    },
                                    {
                                        value: "concern_tantrums",
                                        title: "Temper tantrums",
                                    },
                                    {
                                        value: "concern_cognitive_skills",
                                        title: "Cognitive skills",
                                    },
                                    {
                                        value: "concern_self_injury",
                                        title: "Self injury",
                                    },
                                    {
                                        value: "concern_aggression",
                                        title:
                                            "Aggression (hitting biting, kicking, pushing, scratching, pinching, head butting, pulling hair)",
                                    },
                                    {
                                        value: "concern_self_stimulatory",
                                        title:
                                            "Self stimulatory behaviors (rocking, spinning, flapping hands, visual scrutiny)",
                                    },
                                    {
                                        value: "concern_attention",
                                        title: "Poor attention in many situations",
                                    },
                                    {
                                        value: "concern_impulsivity",
                                        title: "Impulsivity",
                                    },
                                    {
                                        value: "concern_over_activity",
                                        title: "Over activity",
                                    },
                                    {
                                        value: "concern_darting_off",
                                        title: "Darting off",
                                    },
                                    {
                                        value: "concern_muscle_tone",
                                        title: "Muscle tone",
                                    },
                                    {
                                        value: "concern_motor_skills",
                                        title: "Motor skills",
                                    },
                                    {
                                        value: "concern_rituals",
                                        title: "Rituals or routines",
                                    },
                                    {
                                        value: "concern_transitions",
                                        title: "Transitions",
                                    },
                                    {
                                        value: "concern_preoccupations",
                                        title: "Preoccupations",
                                    },
                                    {
                                        value: "concern_self_help_skills",
                                        title: "Self-help skills",
                                    },
                                    {
                                        value: "concern_appetite",
                                        title: "Appetite food selections",
                                    },
                                    {
                                        value: "concern_services",
                                        title: "Services",
                                    },
                                    {
                                        value: "concern_school_environment",
                                        title: "School environment",
                                    },
                                    {
                                        value: "concern_medication",
                                        title: "Medication",
                                    },
                                    {
                                        value: "concern_gastrointestinal",
                                        title: "Gastrointestinal",
                                    },
                                    {
                                        value: "other",
                                        title: "Other",
                                    },
                                ],
                                value: [],
                                enabled: true,
                                required: true,
                            },
                        ],
                        enabled: true,
                        required: true,
                    },
                    {
                        name: "medical_history",
                        title: "Medical history/status",
                        fields: [
                            {
                                name: "medical_precautions",
                                title: "Please include any prescribed medical precautions",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medical_precautions_file",
                                title: "Include physicians note if applicable",
                                type: "file",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medical_restrictions",
                                title: "Please indicate if there are any activity restrictions",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medical_restrictions_file",
                                title: "Include physicians note if applicable",
                                type: "file",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medical_immunization",
                                title: "Is the child up to date on immunization?",
                                type: "radio",
                                options: [
                                    {
                                        value: "yes",
                                        title: "Yes",
                                    },
                                    {
                                        value: "no",
                                        title: "No",
                                    },
                                ],
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medical_immunization_info",
                                title: "If no, why?",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medical_seizures",
                                title: "Does your child have seizures?",
                                type: "radio",
                                options: [
                                    {
                                        value: "yes",
                                        title: "Yes",
                                    },
                                    {
                                        value: "no",
                                        title: "No",
                                    },
                                ],
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medical_other conditions",
                                title: "Other health conditions? (list)",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                        ],
                        sections: [
                            {
                                name: "medical_incidents",
                                title: "Has your child ever had:",
                                fields: [
                                    {
                                        name: "incident_head_injury",
                                        title: "Head injury (age when happened and description)",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "incident_loss_consciosuness",
                                        title:
                                            "Loss of consciousness (age when happened, for how long and description)",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "incident_infections",
                                        title: "Frequent infections (age and description)",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "incident_surgery",
                                        title: "Surgery (age and reason)",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medical_allergies",
                                title: "Allergies",
                                fields: [
                                    {
                                        name: "allergies_medications",
                                        title: "Allergies to medications (list)",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "allergies_medications",
                                        title: "Allergies (not sensitivities) to foods (list)",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "incident_infections",
                                        title: "Frequent infections (age and description)",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "incident_surgery",
                                        title: "Surgery (age and reason)",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medical_hearing",
                                title: "Concerns about hearing",
                                fields: [
                                    {
                                        name: "hearing_last_test_date",
                                        title: "When was the last hearing test",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "hearing_last_test_location",
                                        title: "Where was the child tested",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "hearing_test_results",
                                        title: "What were the results",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "hearing_infections_story",
                                        title:
                                            "Does your child have a history of ear infections? How many?",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "hearing_infections_date",
                                        title: "When was the last occurrence?",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                    {
                                        name: "hearing_tubes",
                                        title:
                                            "Has the child had ear tubes inserted? If so, when were they placed in?",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: false,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                        ],
                        enabled: true,
                        required: true,
                    },
                    {
                        name: "doctors_seen",
                        title: "Doctors seen",
                        sections: [
                            {
                                name: "doctors_primary_pediatrician",
                                title: "Primary pediatrician",
                                fields: [
                                    {
                                        name: "primary_pediatrician_name",
                                        title: "Name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_pediatrician_visit",
                                        title: "Date of last visit",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_pediatrician_diagnosis",
                                        title: "Diagnosis",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "primary_pediatrician_phone",
                                        title: "Phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "doctors_developmental_pediatrician",
                                title: "Developmental pediatrician",
                                fields: [
                                    {
                                        name: "developmental_pediatrician_name",
                                        title: "Name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "developmental_pediatrician_visit",
                                        title: "Date of last visit",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "developmental_pediatrician_diagnosis",
                                        title: "Diagnosis",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "developmental_pediatrician_phone",
                                        title: "Phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "doctors_neurologist",
                                title: "Neurologist",
                                fields: [
                                    {
                                        name: "neurologist_name",
                                        title: "Name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "neurologist_visit",
                                        title: "Date of last visit",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "neurologist_diagnosis",
                                        title: "Diagnosis",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "neurologist_phone",
                                        title: "Phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "doctors_psychiatrist",
                                title: "Psychiatrist",
                                fields: [
                                    {
                                        name: "psychiatrist_name",
                                        title: "Name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "psychiatrist_visit",
                                        title: "Date of last visit",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "psychiatrist_diagnosis",
                                        title: "Diagnosis",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "psychiatrist_phone",
                                        title: "Phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "doctors_geneticist",
                                title: "Geneticist",
                                fields: [
                                    {
                                        name: "geneticist_name",
                                        title: "Name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "geneticist_visit",
                                        title: "Date of last visit",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "geneticist_diagnosis",
                                        title: "Diagnosis",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "geneticist_phone",
                                        title: "Phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "doctors_gastroenterologist",
                                title: "Gastroenterologist",
                                fields: [
                                    {
                                        name: "gastroenterologist_name",
                                        title: "Name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "gastroenterologist_visit",
                                        title: "Date of last visit",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "gastroenterologist_diagnosis",
                                        title: "Diagnosis",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "gastroenterologist_phone",
                                        title: "Phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "gastroenterologist_problems",
                                        title: "Gastrointestinal problems? If yes, describe.",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "doctors_endocrinologist",
                                title: "Endocrinologist",
                                fields: [
                                    {
                                        name: "endocrinologist_name",
                                        title: "Name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "endocrinologist_visit",
                                        title: "Date of last visit",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "endocrinologist_diagnosis",
                                        title: "Diagnosis",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "endocrinologist_phone",
                                        title: "Phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "doctors_other",
                                title: "Other",
                                fields: [
                                    {
                                        name: "other_name",
                                        title: "Name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "other_type",
                                        title: "Type",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "other_visit",
                                        title: "Date of last visit",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "other_diagnosis",
                                        title: "Diagnosis",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "other_phone",
                                        title: "Phone",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                        ],
                        enabled: true,
                        required: true,
                    },
                    {
                        name: "medical_testing",
                        title: "Medical testing",
                        sections: [
                            {
                                name: "test_eeg",
                                title: "EEG (brain wave testing)",
                                fields: [
                                    {
                                        name: "eeg_date",
                                        title: "Date",
                                        type: "text",
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "eeg_results",
                                        title: "Results",
                                        type: "text",
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                            },
                            {
                                name: "test_mri",
                                title: "MRI",
                                fields: [
                                    {
                                        name: "mri_date",
                                        title: "Date",
                                        type: "text",
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "mri_results",
                                        title: "Results",
                                        type: "text",
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                            },
                            {
                                name: "test_ct_scan",
                                title: "CT scan",
                                fields: [
                                    {
                                        name: "cts_date",
                                        title: "Date",
                                        type: "text",
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "cts_results",
                                        title: "Results",
                                        type: "text",
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                            },
                            {
                                name: "test_ophtalmology",
                                title: "Ophtalmology evaluation",
                                fields: [
                                    {
                                        name: "opht_date",
                                        title: "Date",
                                        type: "text",
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "opht_results",
                                        title: "Results",
                                        type: "text",
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                            },
                            {
                                name: "test_chromosomal",
                                title: "Chromosomal/DNA testing",
                                fields: [
                                    {
                                        name: "dna_date",
                                        title: "Date",
                                        type: "text",
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "dna_results",
                                        title: "Results",
                                        type: "text",
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                            },
                            {
                                name: "test_other",
                                title: "Other",
                                fields: [
                                    {
                                        name: "test_other_describe",
                                        title: "Describe",
                                        type: "text",
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "test_other_date",
                                        title: "Date",
                                        type: "text",
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "test_other_results",
                                        title: "Results",
                                        type: "text",
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                            },
                        ],
                        enabled: true,
                        required: true,
                    },
                    {
                        name: "medication_history",
                        title: "Medication history",
                        fields: [
                            {
                                name: "medication_current",
                                title: "Current medications table",
                                listName: "current_meds",
                                listTitle: "Please list the current medication",
                                list: [],
                                listFields: [
                                    {
                                        name: "medication_current_name",
                                        title: "Name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "medication_current_starting_dose",
                                        title: "Starting dose and frequency",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "medication_current_current_dose",
                                        title: "Current dose and frequency",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "medication_current_date_started",
                                        title: "Date started",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "medication_current_effectiveness",
                                        title: "Effectiveness",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "medication_current_prescribed",
                                        title: "Who prescribed",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "medication_current_reason",
                                        title: "Reason",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medication_past",
                                title: "Past medications table",
                                listName: "past_meds",
                                listTitle: "Please list the past medication",
                                list: [],
                                listFields: [
                                    {
                                        name: "medication_past_name",
                                        title: "Name",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "medication_past_starting_dose",
                                        title: "Starting dose and frequency",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "medication_past_past_dose",
                                        title: "Past dose and frequency",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "medication_past_date_started",
                                        title: "Date started",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "medication_past_effectiveness",
                                        title: "Effectiveness",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "medication_past_prescribed",
                                        title: "Who prescribed",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "medication_past_reason",
                                        title: "Reason",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medication_supplements",
                                title:
                                    "Please list any supplements and/or vitamins your child is currently taking and dose",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medication_special_diet",
                                title: "Is your child in any special diets? If so, please explain.",
                                type: "text",
                                value: null,
                                enabled: true,
                                required: true,
                            },
                            {
                                name: "medication_treatments",
                                title: "Other treatments",
                                listName: "other_treatments",
                                listTitle:
                                    "Any other treatments that you have tried that were either helpful or not helpful, we would love to learn from your experience",
                                list: [],
                                listFields: [
                                    {
                                        name: "treatment_other_type",
                                        title: "Type of treatment",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "treatment_other_started",
                                        title: "Date started",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "treatment_other_type",
                                        title: "Type of treatment",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "treatment_other_how_long",
                                        title: "How long you tried",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "treatment_other_outcome",
                                        title: "Outcome",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                    {
                                        name: "treatment_other_recommend",
                                        title:
                                            "Would you recommend it to a parent of a similar child as your child\n",
                                        type: "text",
                                        value: null,
                                        enabled: true,
                                        required: true,
                                    },
                                ],
                                enabled: true,
                                required: true,
                            },
                        ],
                        enabled: true,
                        required: true,
                    },
                ],
            },
        };
    },
    created() {
        this.getPatientData();
    },
    methods: {
        flattenProps(sec, flat) {
            if (sec.hasOwnProperty("fields")) {
                sec.fields.forEach(f => {
                    flat[f.name] = f.value;
                    if (f.hasOwnProperty("list")) {
                        flat[f.listName] = sec.list;
                    }
                });
            }
            if (sec.hasOwnProperty("sections")) {
                sec.sections.forEach(s => {
                    this.flattenProps(s, flat);
                });
            }
            if (sec.hasOwnProperty("list")) {
                flat[sec.listName] = sec.list;
            }
        },
        inflateProps(props, bluePrint) {
            for (let property in props) {
                let sections = this.patientHistory.sections;
                this.updateBluePrint(sections, property, props[property]);
            }
            this.patientHistory.fields.forEach(field => {
                if (field.name in props) {
                    field.value = props[field.name];
                }
            });
            return bluePrint;
        },
        updateBluePrint(sections, fieldName, value) {
            sections.forEach(section => {
                if (section.fields) {
                    section.fields.forEach(field => {
                        if (field.name === fieldName) {
                            field.value = value;
                            if (field.type === "checkbox") {
                                field.options.forEach(option => {
                                    if (value.includes(option.value)) {
                                        option.checked = true;
                                    }
                                });
                            }
                        }
                    });
                }
                if (section.listFields) {
                    if (section.name === fieldName) {
                        section.list = value;
                    }
                }

                /**
                 * If the section has 'sections'. Recursively call itself.
                 */
                if (section.sections) {
                    this.updateBluePrint(section.sections, fieldName, value);
                }
            });
        },
        getPatientData() {
            axios
                .get(`/api/patients/${this.patient.id}`)
                .then(response => {
                    this.patientData = response.data.data.history || {};
                    if (response.data.data.history) {
                        this.patientHistory = this.inflateProps(
                            response.data.data.history,
                            this.patientHistory
                        );
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        },

        save() {
            let flat = {};
            this.flattenProps(this.patientHistory, flat);
            axios
                .patch(`/api/patients/${this.patient.id}`, { history: flat })
                .then(response => {
                    this.edit = false;
                })
                .catch(error => {
                    console.error(error);
                    this.edit = false;
                });
        },
    },
};
</script>
